import React from 'react';
import DeleteObject from '../../common/poppers/DeleteObject';
import LinkRow from './LinkRow';
import DeleteIcon from '@material-ui/icons/Delete';

export const linkActionItems = [
    // {
    //     dataDialog: "modify-dialog",
    //     title: "Módosít",
    //     dialogTitle: "Link módosítása",
    //     actionComponent: (props, close) => <ModifyLink {...props} close={close} />
    // },
    {
        dataDialog: "delete-dialog",
        title: "Törlés",
        dialogTitle: "Link törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <DeleteObject {...props}
            requestObject={{ type: props.row.payable.payableType, payableId: props.row.payable.privateId, linkIds: [props.row.privateId] }}
            close={close}
            path={'/api/link'}
            comp={<LinkRow {...props} />} />
    },
]